// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"44cf95ad","209":"d464d894","312":"a89dcbe9","562":"236d14c1","711":"847cfebd","922":"fefd4601","964":"89653c5c"}[chunkId] + ".chunk.js";
};